var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5417 12.0833C15.8787 12.0833 12.0833 15.8775 12.0833 20.5417C12.0833 25.2058 15.8787 29 20.5417 29C25.2046 29 29 25.2058 29 20.5417C29 15.8775 25.2046 12.0833 20.5417 12.0833ZM20.5417 26.5833C17.2103 26.5833 14.5 23.873 14.5 20.5417C14.5 17.2103 17.2103 14.5 20.5417 14.5C23.873 14.5 26.5833 17.2103 26.5833 20.5417C26.5833 23.873 23.873 26.5833 20.5417 26.5833ZM21.75 20.0414L23.8126 22.104L22.104 23.8126L19.3333 21.0419V16.9167H21.75V20.0414ZM29 6.04167V13.7134C28.3125 12.8627 27.4932 12.128 26.5833 11.5166V6.04167C26.5833 5.37587 26.042 4.83333 25.375 4.83333H3.625C2.95921 4.83333 2.41667 5.37587 2.41667 6.04167V9.66667H20.5417C17.9534 9.66667 15.5803 10.5741 13.7134 12.0833H2.41667V26.5833H11.5009C12.1123 27.4968 12.8603 28.31 13.7134 29H0V6.04167C0 4.04308 1.62642 2.41667 3.625 2.41667H7.25V0H9.66667V2.41667H19.3333V0H21.75V2.41667H25.375C27.3736 2.41667 29 4.04308 29 6.04167Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveLogo);
export default __webpack_public_path__ + "static/media/archive-logo.0c20bd38135a798126c88e05df166987.svg";
export { ForwardRef as ReactComponent };